import { MyTodoListTable } from './MyTodoListTable';

export const MyTodoList = () => <MyTodoListTable />;
